import ApiService from './ApiService';

class GeneralApi extends ApiService {

    constructor() {
        super('');
    }

    getAllExchanges(payload) {
        return this.get('exchanges', payload);
    }

    getAllBlockchainNetwork(payload) {
        return this.get('blockchain-networks', payload);
    }

    getAllTokens(payload) {
        return this.get('tokens', payload);
    }
}

export default GeneralApi;
